<template>
    <div class="betslip-stake__container">
        <div class="betslip-stake__row">
            <div class="betslip-stake">
                <span class="betslip-stake__label">{{ $t('your stake') | capitalize }}:</span>
                <StakePicker
                    @click="onStakePick"
                    :stake="stake"
                />
            </div>
            <div class="betslip-stake">
                <span class="betslip-stake__currency-label">
                    {{ $t('currencyAbbreviation') }}
                </span>
                <StakeInput
                    :stake="stake"
                    @stakeChanged="onChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import StakeInput from './StakeInput.vue';
    import StakePicker from './StakePicker.vue';

    export default {
        name: 'Stake',
        props: {
            stake: {
                type: Number,
                require: false,
            }
        },
        methods: {
            onChange(stake) {
                this.$emit('change', stake);
            },
            onStakePick(stake) {
                this.$emit('stakePick', stake);
            },
        },
        components: {
            StakeInput,
            StakePicker
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Stake.vue